import { useState } from "react"
import { wrapPointDataWithConditions } from "../Utils/PersonChartDataProcess"
import { BubbleChart } from "./Charts/BubbleChart"
import { ZoneChart2, ZoneChart } from "./Charts/ZoneChart"
import { pitchNameMapping } from "./FilterFrame"
import { FormSelectionBox, SingleSelectionBox, SingleSelectionBox2 } from "./InputBox"
import { useFormContext } from "react-hook-form"
import { H2HKZoneConfig2 } from "./Charts/configs/h2h_config"
import { PersonTable } from "./PersonFrame"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleExclamation, faCircleInfo } from "@fortawesome/free-solid-svg-icons"

const KZoneGraphFrame = ({title=false, classname, graph}) => {
  return (
    <div className='kgframe'>
      <div className="kgf-title">
        {title? title:[]}
      </div>
      <div className='wbkg_tab_content'>
        <div className={classname}>
          {graph}
        </div>
      </div>
    </div>
  )
}

export const H2HKZoneFrame = ({data}) => {
  // console.log(data)
  return (
    <>
      <div className="page_tab_frame2">
        <div className="tab_block tab_selected">
          <div className="tab">總覽</div>
        </div>
      </div>
      <div className="person_tab_content">
        <div className="h2h-kzone-body">
          <KZoneGraphFrame title="直球進壘" graph={<ZoneChart2 title="FB" type='pitcher_pitch_pct' zone={data.fb} />} />
          <KZoneGraphFrame title="變化球進壘" graph={<ZoneChart2 title="Non-FB" type='pitcher_pitch_pct' zone={data.nfb} />} />
          <KZoneGraphFrame title="打擊率" graph={<ZoneChart title="AVG" type='pavg' zone={data.avg} />} />
          <KZoneGraphFrame title="揮空率" graph={<ZoneChart2 title="Whiff" type='pitcher_whiff' zone={data.whiff} />} />
        </div>
      </div>
    </>
  )
}

export const H2HTableFrame = ({stat, discipline}) => {
  const stats_headers = ['PA', 'AB', 'H', '2B', '3B', 'HR', 'BB', 'IBB', 'SO', 'BABIP', 'ISO', 'AVG', 'OBP', 'SLG', 'OPS']
  const discipline_headers = ['Type', 'Total#','Total%','Strike#','Strike%','Zone#','Zone%','Swing#','Swing%','Stk_Swing%','Z-Swing%','O-Swing%','Contact#','Contact%','Z-Contact%','O-Contact%','Miss#','Whiff%','Swtr%','InPlay#','InPlay%']
  const TableHeader = ({headers}) => {
    return (
      <tr>
        {headers.map((e)=>(<th>{e}</th>))}
      </tr>
    )
  }
  const TableData = ({title, data, leftitle=false}) => {
    // console.log(data, leftitle)
    return (
      <tr>
        {leftitle? <td className="left_title">{title} <span>{pitchNameMapping[title]}</span></td>:[]}
        {data.map((e)=>(<td>{e}</td>))}
      </tr>
    )
  }
  return (
    <div className="filter_table">
      <div className="page_tab_frame2">
        <div className="tab_block tab_selected">
          <div className="tab">數據</div>
        </div>
      </div>

      <div className="person_tab_content">
        <div className="h2h-tables">
          <table className="filter_form">
            <TableHeader headers={stats_headers} />
            <tbody>
              <TableData data={stat} />
            </tbody>
          </table>
        </div>

        <div className="h2h-tables">
          <table className="filter_form">
            <TableHeader headers={discipline_headers} />
            <tbody>
              {discipline.map((e) => {
                if (pitchNameMapping[e.title] === undefined) return []
                return <TableData title={e.title} data={e.data} leftitle />
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export const extractBallCount = (data) => {
  return data.map((p => ({ x: parseFloat(p.APP_KZoneY), y: parseFloat(p.APP_KZoneZ), tag: p.TaggedPitchType, count: p.BS, pside: p.PT, bside: p.BatS })))
}

export const H2HPitchLocationFrame = ({data, title}) => {
  const [type, setType] = useState(title)
  const ptypes = ['FB', 'SL', 'CH', 'CB', 'SP', 'SFF', 'SC', 'CT', 'FT', 'KN', 'UN', 'OT']
  const countMap = {
    '0-0': ['0-0'], '1-0': ['1-0'], '2-0': ['2-0'], '3-0': ['3-0'], '0-1': ['0-1'], '1-1': ['1-1'],
    '2-1': ['2-1'], '3-1': ['3-1'], '0-2': ['0-2'], '1-2': ['1-2'], '2-2': ['2-2'], '3-2': ['3-2'],
    blead: ['1-0','2-0','3-0','2-1','3-1'], plead: ['0-1','0-2','1-2'], strike2: ['0-2','1-2','2-2','3-2'], even: ['0-0','1-1','2-2']
  }
  const countLabel = {'0-0': '首球(0-0)', blead: '打者領先', plead: '投手領先', strike2: '2好球', even: '平手'}
  return (
    <div className="h2h-pitch-frame">
      <div className="h2h-pf-title"><SingleSelectionBox2 options={Object.keys(countMap)} optionValueMap={countLabel} value={type} handleOnChange={(e)=>{setType(e.target.value)}} /></div>
      <div className="h2h-pf-content">
        <BubbleChart data={wrapPointDataWithConditions(extractBallCount(data), 'pside', 'all', ptypes, countMap[type])} config={H2HKZoneConfig2} />
      </div>
    </div>
  )
}

export const ConditionFilterFrame = ({type, options, optionMaps}) => {
  const form = useFormContext()
  const valueMap = {
    'Pitcher': {
      title: '投手',
      team: 'PitcherTeam',
      name: 'Pitcherid'
    },
    'Batter': {
      title: '打者',
      team: 'BatterTeam',
      name: 'Batterid'
    }
  }
  const PlayerOptions = (type) => {
    const ttag = form.watch(valueMap[type]['team'])
    const type_zh = type==="Pitcher"? "投手":"打者"
    if (ttag === undefined || ttag[0] === undefined || ttag === '隊伍') {
      // console.log(type, ttag, options, optionMaps)
      return { options: [], optionTags: undefined }
    }
    if (ttag === '中華職棒') {
      return { options: [`全部${type_zh}`, 'left', 'right'], optionTags: { left: `左${type_zh}`, right: `右${type_zh}`} }
    }
    return { options: [`全部${type_zh}`, 'left', 'right', ...options[1][ttag][type.toLowerCase()]], optionTags: { left: `左${type_zh}`, right: `右${type_zh}`, ...optionMaps[1][ttag][type.toLowerCase()]} }
  }
  return (
    <div className="h2h-cond-filter">
      <div className="h2h-cf-title">{valueMap[type]['title']}</div>
      <div className="h2h-cf-selects">
        <FormSelectionBox name={valueMap[type]['team']} options={options[0]} optionTags={optionMaps[0]} />
        <FormSelectionBox name={valueMap[type]['name']} {...PlayerOptions(type)} />
      </div>
    </div>
  )
}

export const H2HEmptyFrame = ({error}) => {
  const icon = error? <FontAwesomeIcon icon={faCircleExclamation} color="red" /> : <FontAwesomeIcon icon={faCircleInfo} />
  const message = error? '搜尋條件至少須包含一支隊伍' : '設定條件以搜尋對戰組合'
  return (
    <div className="frame_empty">
      {icon}
      <p className="empty_msg">{message}</p>
    </div>
  )
}

export const H2HPLocFrame = ({data}) => {
  // console.log(data)
  const [mode1, setMode1] = useState('all')
  const [mode2, setMode2] = useState('hit')
  const modeTags = {
    all: '進壘位置', take: '好球未出棒', swing_m: '揮空', inplay: '擊出',
    hit: '安打', xbh: '長打', go: '滾地出局', fo: '飛球出局'
  }
  const LocModes = ({mode, modes, setMode}) => {
    return (
      <div className="loc-modes-bbody">
        <div className="loc-modes">
          {modes.map((e)=>(<div className={`loc-mode-title${e===mode? " loc-sel-title":""}`} onClick={()=>{setMode(e)}}><div>{modeTags[e]}</div></div>))}
        </div>
      </div>
    )
  }
  return (
    <>
      <div className="page_tab_frame2">
        <div className="tab_block tab_selected">
          <div className="tab">進壘點</div>
        </div>
      </div>
      <div className="person_tab_content">
        <div>
          <LocModes mode={mode1} modes={['all', 'take', 'swing_m', 'inplay']} setMode={setMode1} />
          <div className="h2h-pf-body">
            <H2HPitchLocationFrame data={data[mode1]} title='0-0' />
            <H2HPitchLocationFrame data={data[mode1]} title='blead' />
            <H2HPitchLocationFrame data={data[mode1]} title='plead' />
            <H2HPitchLocationFrame data={data[mode1]} title='strike2' />
          </div>
        </div>
        <div>
          <LocModes mode={mode2} modes={['hit', 'xbh', 'go', 'fo']} setMode={setMode2} />
          <div className="h2h-pf-body">
            <H2HPitchLocationFrame data={data[mode2]} title='0-0' />
            <H2HPitchLocationFrame data={data[mode2]} title='blead' />
            <H2HPitchLocationFrame data={data[mode2]} title='plead' />
            <H2HPitchLocationFrame data={data[mode2]} title='strike2' />
          </div>
        </div>
      </div>
    </>
  )
}